<div class="status-badge" [ngClass]="cssClass"></div>
